<div class="jumbotron bg-white text-primary">
    <div class="container">
        <div class="text-center">
            <h2>Serviços</h2>
            <p class="text-secondary">Lorem ipsum</p>
        </div>
    </div>
</div>

<div class="container">
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eget ligula eu lectus lobortis condimentum. Aliquam nonummy auctor massa. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nulla at risus. Quisque purus magna, auctor et, sagittis ac, posuere eu, lectus. Nam mattis, felis ut adipiscing.</p>
</div>

<app-solicitar-orcamento></app-solicitar-orcamento>